export default __webpack_public_path__ + "static/media/cancer.24a45234.png";